import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { Logo } from '../../component/util/logo'
import { RequestForgotPasswordStep } from '../../component/account/forgot-password/request-forgot-password-step'
import { VerifyForgotPasswordEmailStep } from '../../component/account/forgot-password/verify-forgot-password-email-step'
import styles from '../../component/account/forgot-password/forgot-password.module.scss'

export const ForgotPasswordScreen = (): React.ReactElement => {
  return (
    <div className="floating-form">
      <div className={`form ${styles.form}`}>
        <div className={`${styles.logoContainer} text-center`}>
          <Logo />
        </div>
        <div className={`form-group ${styles.inputContainerGroup}`}>
          <Switch>
            <Route exact path="/forgot-password/" component={RequestForgotPasswordStep} />
            <Route
              exact
              path="/forgot-password/verify-email/:email"
              component={(props: any) => <VerifyForgotPasswordEmailStep email={props.match.params.email} />}
            />
          </Switch>
        </div>
      </div>
    </div>
  )
}
